import produce from 'immer'
import { assign, filter, map } from 'lodash'

import { CREATE_SOP, DELETE_SOP, FETCH_SOPS } from '../action-types'
import { SOPS_INITIAL_STATE } from '../initial-states'

const sopsReducer = (state = SOPS_INITIAL_STATE, action) => {
  switch (action.type) {
    // Fetch
    case FETCH_SOPS.START:
      return produce(state, nextState =>
        assign(nextState, {
          fetchingError: undefined,
          isFetching: true,
        }),
      )
    case FETCH_SOPS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          fetchingError: action.error.message,
          isFetching: false,
        }),
      )
    case FETCH_SOPS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          fetchingError: undefined,
          isFetching: false,
          data: action.payload.data.sops,
        }),
      )
    case FETCH_SOPS.CLEANUP:
      return { ...SOPS_INITIAL_STATE }

    // Create
    case CREATE_SOP.START:
      return produce(state, nextState =>
        assign(nextState, {
          creatingError: undefined,
          isCreating: true,
        }),
      )
    case CREATE_SOP.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          creatingError: action.error.message,
          isCreating: false,
        }),
      )
    case CREATE_SOP.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          creatingError: undefined,
          isCreating: false,
          data: [...nextState.data, action.payload.data.createSop],
        }),
      )

    // Delete
    case DELETE_SOP.START:
      return produce(state, nextState =>
        assign(nextState, {
          data: map(nextState.data, sop =>
            sop.id === action.payload.id
              ? {
                  ...sop,
                  deletingError: undefined,
                  isDeleting: true,
                }
              : sop,
          ),
        }),
      )
    case DELETE_SOP.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          data: map(nextState.data, sop =>
            sop.id === action.payload.variables.id
              ? {
                  ...sop,
                  deletingError: action.error.message,
                  isDeleting: false,
                }
              : sop,
          ),
        }),
      )
    case DELETE_SOP.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          data: filter(
            nextState.data,
            sop => sop.id !== action.payload.variables.id,
          ),
        }),
      )

    default:
      return state
  }
}

export default sopsReducer
